// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__tG8VB","tab":"ProcedureTabs_tab__3lhiZ"};